<template>
  <div>
    <md-dialog
      :md-active.sync="showDialog"
      :md-click-outside-to-close="false"
      v-resize="onResize"
    >
      <md-dialog-title class="text-center">Secure ID Verification</md-dialog-title>
      <md-dialog-content>
        <h6>Use existing SIDV code.</h6>
        If you have verified your ID with SecureIDverify previously on this site or
        another site that uses our service, simply enter your SIDV code here and you will
        be fast-tracked through the verification process.
        <div class="complete_content">
          <input type="text" placeholder="enter SIDV code" class="input_SIDV" />
        </div>
        <md-dialog-actions>
          <div>
            <md-button class="md-raised md-primary btn-element" @click="go_complete()"
              >Next ></md-button
            >
          </div>
        </md-dialog-actions>
        <div class="text-center">
          <img class="logo-size" src="@/assets/logo.png" />
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "ExistSIDV",

  data: () => ({
    message: "QVK8VDA7",
    showDialog: true,
  }),

  methods: {
    go_complete() {
      this.$router.push({ name: "CompleteExist" });
    },
    onCopy: function (e) {
      console.log("sadfS");
      alert("You just copied the following text to the clipboard: " + e.text);
    },
    onError: function (e) {
      alert("Failed to copy the text to the clipboard");
      console.log(e);
    },
    onResize({ width, height }) {
      window.onResizeHandler(width, height);
    },
  },

  mounted() {},
};
</script> 

<style lang="scss" scoped>
.input_SIDV {
  padding: 5px;
}
.copy_button {
  border: unset;
  width: 35px;
  height: 35px;
  background-color: white;
  padding-left: 5px;
}
.top_pad {
  padding-top: 20px;
}
.verify_code {
  font-size: 20px;
  padding: 10px;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 10%;
  border: 2px dotted black;
  border-radius: 10px;
}

.sucess_avatar {
  width: 150px;
}

.complete_content {
  padding: 10px;
  display: flex;
  justify-content: center;
}

.logo-size {
  width: 150px;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #73c773;
  border-radius: 10px;
  padding-left: 40px;
  padding-right: 40px;
  color: white !important;
}

.md-dialog-actions {
  justify-content: center;
}

.btn-element {
  margin: 1% !important;
  color: black !important;
  font-size: 12px;
}

ul {
  margin-top: 1rem !important;
  margin-bottom: 0rem !important;
}

.md-dialog {
  ::v-deep .md-dialog-container {
    max-width: 500px;
    border-radius: 20px !important;
    border: 3px solid black;
  }
}
</style>